import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import mechImg from '../img/aaaservices/VR.webp';
import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
import itImg1 from '../img/aaaservices/PY.jpg';
import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';

const jobData = {
  Mechanical: [
    {
      id: 1,
      title: "Design Engineer",
      subtitle: "CAD/Tool Design",
      experience: "2+ years",
      ctc: "₹4.5 LPA",
      description: "Responsible for creating 3D models and assemblies in SolidWorks.",
      image: mechImg,
      link: "/mech-job-1"
    },
    {
      id: 1,
      title: "Design Engineer",
      subtitle: "CAD/Tool Design",
      experience: "2+ years",
      ctc: "₹4.5 LPA",
      description: "Responsible for creating 3D models and assemblies in SolidWorks.",
      image: mechImg,
      link: "/mech-job-1"
    },
    {
      id: 1,
      title: "Design Engineer",
      subtitle: "CAD/Tool Design",
      experience: "2+ years",
      ctc: "₹4.5 LPA",
      description: "Responsible for creating 3D models and assemblies in SolidWorks.",
      image: mechImg,
      link: "/mech-job-1"
    },
    {
      id: 2,
      title: "Simulation Analyst",
      subtitle: "FEA Specialist",
      experience: "3-5 years",
      ctc: "₹6 LPA",
      description: "Perform static and dynamic analysis using ANSYS.",
      image: simImg,
      link: "/mech-job-2"
    }
  ],
  IT: [
    {
      id: 1,
      title: "Full Stack Developer",
      subtitle: "Java + React",
      experience: "1-3 years",
      ctc: "₹7 LPA",
      description: "Develop scalable web applications using Spring Boot & React.",
      image: itImg,
      link: "/it-job-1"
    },
    {
      id: 1,
      title: "Full Stack Developer",
      subtitle: "Java + React",
      experience: "1-3 years",
      ctc: "₹7 LPA",
      description: "Develop scalable web applications using Spring Boot & React.",
      image: itImg,
      link: "/it-job-1"
    },
    {
      id: 1,
      title: "Full Stack Developer",
      subtitle: "Java + React",
      experience: "1-3 years",
      ctc: "₹7 LPA",
      description: "Develop scalable web applications using Spring Boot & React.",
      image: itImg,
      link: "/it-job-1"
    },
    {
      id: 2,
      title: "Python Developer",
      subtitle: "Django/Flask",
      experience: "2+ years",
      ctc: "₹5.5 LPA",
      description: "Create RESTful APIs and backend logic in Python.",
      image: itImg1,
      link: "/it-job-2"
    }
  ],
  Digital: [
    {
      id: 1,
      title: "Digital Trainer",
      subtitle: "Soft Skills + Tech Tools",
      experience: "Fresher",
      ctc: "₹3.5 LPA",
      description: "Train students on communication and basic digital tools.",
      image: dfsImg1,
      link: "/digital-job-1"
    },
    {
      id: 1,
      title: "Digital Trainer",
      subtitle: "Soft Skills + Tech Tools",
      experience: "Fresher",
      ctc: "₹3.5 LPA",
      description: "Train students on communication and basic digital tools.",
      image: dfsImg1,
      link: "/digital-job-1"
    },
    {
      id: 1,
      title: "Digital Trainer",
      subtitle: "Soft Skills + Tech Tools",
      experience: "Fresher",
      ctc: "₹3.5 LPA",
      description: "Train students on communication and basic digital tools.",
      image: dfsImg1,
      link: "/digital-job-1"
    }
  ]
};

const JobListingComponent = () => {
  const [selectedBranch, setSelectedBranch] = useState('All');
  const [experienceFilter, setExperienceFilter] = useState('');
  const [locationFilter, setLocationFilter] = useState(""); // ✅ Add this
const [ctcFilter, setCtcFilter] = useState(""); 
const [workModeFilter, setWorkModeFilter] = useState("");
const [educationFilter, setEducationFilter] = useState("");

  const navigate = useNavigate();

  const getFilteredJobs = () => {
    let data =
      selectedBranch === 'All'
        ? [...jobData.Mechanical, ...jobData.IT, ...jobData.Digital]
        : jobData[selectedBranch] || [];

    if (experienceFilter) {
      data = data.filter((job) =>
        job.experience.toLowerCase().includes(experienceFilter.toLowerCase())
      );
    }
    if (locationFilter) {
      data = data.filter(job =>
        job.location.toLowerCase().includes(locationFilter.toLowerCase())
      );
    }

    if (ctcFilter) {
      data = data.filter(job => job.ctc === ctcFilter);
    }

    if (workModeFilter) {
      data = data.filter(job => job.workMode === workModeFilter);
    }

    if (educationFilter) {
      data = data.filter(job => job.education === educationFilter);
    }

    
    

    return data;
  };

  return (
    <div className="filter-container">
      <div className="sidebar">
        <h3>Filter Jobs</h3>
        <select onChange={(e) => setSelectedBranch(e.target.value)} value={selectedBranch}>
          <option value="All">All</option>
          <option value="Mechanical">Mechanical</option>
          <option value="IT">IT</option>
          <option value="Digital">Digital</option>
        </select>

        <select value={experienceFilter} onChange={(e) => setExperienceFilter(e.target.value)}>
          <option value="">Experience</option>
          <option value="Fresher">Fresher</option>
          <option value="1">1+ years</option>
          <option value="2">2+ years</option>
          <option value="3">3+ years</option>
          <option value="5">5+ years</option>
        </select>

        <select value={locationFilter} onChange={(e) => setLocationFilter(e.target.value)}>
            <option value="">Select Location</option>
            <option value="Pune">Pune</option>
            <option value="Bangalore">Bangalore</option>
            <option value="Hyderabad">Hyderabad</option>
            <option value="Remote">Remote</option>
            <option value="Mumbai">Mumbai</option>
            <option value="Delhi">Delhi</option>
            <option value="Chennai">Chennai</option>
            <option value="Kolkata">Kolkata</option>
          </select>

          <select value={ctcFilter} onChange={(e) => setCtcFilter(e.target.value)}>
            <option value="">Select CTC</option>
            <option value="₹3 LPA">₹3 LPA</option>
            <option value="₹3.5 LPA">₹3.5 LPA</option>
            <option value="₹4.2 LPA">₹4.2 LPA</option>
            <option value="₹4.5 LPA">₹4.5 LPA</option>
            <option value="₹5 LPA">₹5 LPA</option>
            <option value="₹5.5 LPA">₹5.5 LPA</option>
            <option value="₹6 LPA">₹6 LPA</option>
            <option value="₹7 LPA">₹7 LPA</option>
          </select>
          <select value={workModeFilter} onChange={(e) => setWorkModeFilter(e.target.value)}>
  <option value="">Work Mode</option>
  <option value="Hybrid">Hybrid</option>
  <option value="Remote">Remote</option>
  <option value="On-Site">On-Site</option>
</select>

<select value={educationFilter} onChange={(e) => setEducationFilter(e.target.value)}>
  <option value="">Education</option>
  <option value="Diploma">Diploma</option>
  <option value="B.Tech">B.Tech</option>
  <option value="M.Tech">M.Tech</option>
  <option value="Any Graduate">Any Graduate</option>
</select>

      </div>

      <div className="card-section">
        {getFilteredJobs().map((job) => (
          <div className="card" key={job.id} onClick={() => navigate(job.link || "#")}>
            <img src={job.image} alt={job.title} />
            <div style={{padding:'10px',fontWeight:'',fontFamily:'math'}} className="card-contentsy">
              <p style={{ fontSize: '22px', color: 'blue' }}>{job.title}</p>
              {/* <p>{job.subtitle}</p> */}
              <p><strong>Experience:</strong> {job.experience}</p>
              <p><strong>CTC:</strong> {job.ctc}</p>
              <p><strong>Location:</strong> {job.location}</p>
              <p><strong>Work Mode:</strong> {job.workMode}</p>
              <p><strong>Education:</strong> {job.education}</p>
              {/* <p>{job.description}</p> */}
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .filter-container {
          display: flex;
          gap: 20px;
          padding: 20px;
        }

        .sidebar {
          min-width: 239px;
          max-width: 339px;
          background: #f9f9f9;
          padding: 15px;
          border-radius: 8px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          height: fit-content;
        }

        .sidebar select {
          width: 100%;
          padding: 8px;
          margin-bottom: 15px;
          font-size: 15px;
          border-radius: 5px;
          border: 1px solid #ccc;
        }

        .card-section {
          flex: 1;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }

        .card {
          background: #fff;
          border-radius: 10px;
          border: 1px solid #ddd;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.2s ease;
        }

        .card:hover {
          transform: translateY(-5px);
        }

        .card img {
          width: 100%;
          height: 160px;
          object-fit: cover;
        }

        .card-content {
          padding: 0px 15px;
        }

        .card-contentsy p {
          color: #222;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          font-size: 15px;
          margin: 5px 0;
        }

        @media (max-width: 992px) {
          .card-section {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 600px) {
          .filter-container {
            flex-direction: column;
          }

          .sidebar {
            width: 100%;
          }

          .card-section {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default JobListingComponent;
